/* eslint-disable id-denylist */
import Model from '@/models/Model.js';

export default class WidgetTemplate extends Model {
    static entity = 'widget_layout_templates';

    static modelName = 'WidgetLayoutTemplate';

    static fields() {
        return {
            id: this.attr(null),
            layout_name: this.attr(null),
            widget: this.attr(null),
            type: this.attr(null),
            color: this.attr(null),
            layout_x: this.attr(null),
            layout_y: this.attr(null),
            layout_width: this.attr(null),
            layout_height: this.attr(null),
            deleted_at: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),

            ...super.fields(),
        };
    }

    /**
     * @returns {{w: (number|*), x: (number|*), h: (number|*), name: *, y: (*|number), i}}
     */
    get layout() {
        return {
            x: this.layout_x,
            y: this.layout_y,
            w: this.layout_width,
            h: this.layout_height,
            i: this.id,
            name: this.widget,
        };
    }
}
